// removed by extract-text-webpack-plugin
module.exports = {"item-dropdown":"ConnectionItemDropdown__item-dropdown___3wNyg"};